<div *ngIf="filterActive" class="wrapper wrapper-content animated fadeInRight" [@slideIn]="filterActive">
  <div class="row">
    <div class="col-12">
      <div class=" float-e-margins">
        <div class="form_search">
          <div class="m-b">
            <div class="form-group form-filter">
              <h3>Filtros</h3>
              <div class="col-8 d-flex justify-content-end">
                <button class="btn-filters" type="button" (click)="onCleanSearch()">
                  <img src="assets/images/svgs/Limpar_filtros.svg">
                  <span>Limpar Filtros</span>
                </button>
                <button class="btn-filters-close" type="button" (click)="onCloseFilter()">
                  <img src="assets/images/svgs/Fechar.svg" alt="Pesquisar">
                </button>
              </div>
            </div>
          </div>
          <form [formGroup]="formFilter">
            <div class="form-group row">
              <ng-content></ng-content> 
              <div class="col-sm-4 col-xl-6 m-b">
                <div class="search-button">
                  <button type="button" (click)="onSearch()">Filtrar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
